import { Router } from "@angular/router";
import { CommonservicesService } from "app/_services/commonservices.service";
import {
  ApexNonAxisChartSeries,
  ApexPlotOptions,
  ApexChart,
  ApexLegend,
  ApexResponsive
} from "ng-apexcharts";
import { Component } from "@angular/core";
export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  colors: string[];
  legend: ApexLegend;
  plotOptions: ApexPlotOptions;
  responsive: ApexResponsive | ApexResponsive[];
};
 
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent   {
 
  userCount: number=0;
  productCount: number=0;
  categoryCount: number=0;
  subcategoryCount: number =0;
  dataCenterCount: number = 0;
  assetUserCount:number = 0;
  resultLength: number = 0;
  isLoaderResult: boolean;
 
  constructor(
    private readonly  commonService: CommonservicesService,
    private readonly router: Router,
  ) {
    this.isLoaderResult = false;
  }

  

  ngOnInit(): void {
    this.isLoaderResult = true;
    this.setUserProductCatSubcatCount();
  }

  setUserProductCatSubcatCount() {
    this.commonService.getUserProductCatSubcatCount().subscribe((data) => {
      this.userCount = data.userCount;
      this.productCount = data.productCount;
      this.categoryCount = data.categoryCount;
      this.subcategoryCount = data.subcategoryCount;
      this.dataCenterCount = data.datacenterCount;
      this.assetUserCount = data.assetUserCount;
      this.isLoaderResult = false;
    });
  }

  showUsers() {
    this.router.navigateByUrl("user-management");
  }
 
  showProducts() {
    this.router.navigateByUrl("masters/product-master");
  }

  showCategories() {
    this.router.navigateByUrl("masters/category-master");
  }

  showSubCategories() {
    this.router.navigateByUrl("masters/sub-category");
  }
 
  showDatacenters() {
    this.router.navigateByUrl("masters/datacenter");
  }

  showBanks() {
    this.router.navigateByUrl("masters/BankMaster/list-bank-master");
  }

  showSites() {
    this.router.navigateByUrl("masters/SiteMaster/list-site-master");
  }
  showAtms() {
    this.router.navigateByUrl("masters/AtmMaster/list-atm-master");
  }

  showAssetUsers ()
  {
      this.router.navigateByUrl('masters/assetusers');
  }
 
}
   